import React from 'react'
import type { GetStaticProps } from 'next'
import OilRecyclingPage from '@src/components/DisposalPage/pages/OilRecyclingPage'
import { getCityLinks, type CityLinksData } from '@src/content/cities'
import N8nChatEmbed from '@src/components/DisposalPage/N8nChatEmbed'
import useExperimentVariant from '@src/hooks/useExperimentVariant'
import { FLAG_OIL_RECYCLING_CHAT, IS_LOCAL_DEV } from '@src/functions/featureFlags'
import pageClasses from '@src/styles/oil-recycling-page.module.css'

/**
 * `/oil-recycling`, with the right-hand hero column chosen by the
 * `oil-recycling-n8n-chatbot` LaunchDarkly flag: the n8n quoting chatbot for the
 * treatment group, the default CTA card for everyone else.
 *
 * Same setup as `/paint-disposal` — control is the fallback for server-rendered HTML,
 * first paint, LaunchDarkly blocked or slow, and crawlers; `ctaContainerClassName`
 * reserves the taller variant's height for both groups so the swap costs no CLS; and
 * under `yarn dev` the chatbot is always shown without evaluating the flag.
 */
type Props = { cityLinks: CityLinksData | null }

/**
 * Built at build time so the city registry stays out of the client bundle —
 * see getCityLinks. The flag below still decides the hero client-side.
 */
export const getStaticProps: GetStaticProps<Props> = async () => ({
  props: { cityLinks: getCityLinks('oil-recycling') },
})

function OilRecycling({ cityLinks }: Props) {
  const { enabled } = useExperimentVariant(FLAG_OIL_RECYCLING_CHAT, false, {
    skip: IS_LOCAL_DEV,
  })
  const showChat = IS_LOCAL_DEV || enabled

  return (
    <OilRecyclingPage
      heroAside={showChat ? <N8nChatEmbed service='oil-recycling' /> : undefined}
      ctaContainerClassName={pageClasses.heroAsideReserve}
      cityLinks={cityLinks}
    />
  )
}

export default OilRecycling
